import { ChartSwiper } from "./ChartSwiper";

export default ChartSwiper;
